import { connect } from 'react-redux';
import { IState } from '../../../../../store/types';
import { getAudioById } from '../../../../../store/models/selectors';
import { getCurrentAudioId } from '../../../../../store/current-video/selectors';
import { getBookHost, getBookReloadKey, isBookCreating, isBookHostFailed, isBookRegenerating } from '../../../../../store/books/selectors';
import { hasUsableTranscript } from '../../../../../../common/utils/audioTranscriptUtil';
import { BookTab } from '../components/BookTab';
import { IBookTabEvents, IBookTabFields } from '../components/types';
import { BookTabEvents } from './events';

const mapStateToProps = (
	state: IState
): IBookTabFields => {
	const audioId = getCurrentAudioId(state);
	const audio = audioId ? getAudioById(state, audioId) : undefined;
	const bookId = audio?.bookId;
	return {
		bookId,
		canCreateBook: hasUsableTranscript(audio),
		creating: !!audioId && isBookCreating(state, audioId),
		regenerating: !!bookId && isBookRegenerating(state, bookId),
		bookHost: getBookHost(state),
		bookHostFailed: isBookHostFailed(state),
		reloadKey: bookId ? getBookReloadKey(state, bookId) : 0,
	};
}

const mapDispatchToProps = (
	dispatch: any
): IBookTabEvents => ({
	onCreateBook: () => dispatch(BookTabEvents.onCreateBook()),
	onLoadBookHost: () => dispatch(BookTabEvents.onLoadBookHost()),
	onGetToken: () => dispatch(BookTabEvents.onGetToken()),
	onBook: (book) => dispatch(BookTabEvents.onBook(book)),
	onReaderError: (error) => dispatch(BookTabEvents.onReaderError(error)),
});

export const BookTabHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(BookTab);

BookTabHOC.displayName = 'BookTabHOC';
